import React, { useMemo } from 'react';
import { string, object, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import { SUBSCRIPTION_STATUS } from '../../constants/payment.constants';
import ExternalLink from '../../components/ExternalLink/ExternalLink';
import { IconSpinner } from '../../components';
import { formatRenewalDateBasedOnSubscriptionStatus } from '../../util/dates';

import css from './PaymentMethodsPage.module.css';

const PaymentMethodsSubscriptionActive = props => {
  const { url, urlInProgress, urlError, subscription } = props;

  const {
    plan: selectedPlan,
    expiresAt: renewalDate,
    state: subscriptionStatus,
    nextState,
    nextPlan,
  } = subscription;

  const renewalDateFormatted = formatRenewalDateBasedOnSubscriptionStatus(
    renewalDate,
    subscriptionStatus
  );

  const expiresAt = formatRenewalDateBasedOnSubscriptionStatus(renewalDate);

  return (
    <div className={css.paymentMethodsSubscriptionActive}>
      <span className={css.selectedPlan}>
        <strong className={css.strong}>
          <FormattedMessage id="PaymentMethodsSubscriptionActive.selectedPlan" />
        </strong>
        <FormattedMessage id={`General.paymentMethods.${selectedPlan}`} />
      </span>
      {nextPlan && nextPlan !== selectedPlan && (
        <span className={css.selectedPlan}>
          <strong className={css.strong}>
            <FormattedMessage id="PaymentMethodsSubscriptionActive.nextPlan" />
          </strong>
          <FormattedMessage
            id={`PaymentMethodsSubscriptionActive.nextPlanStarts`}
            values={{
              expiresAt,
              nextPlan: <FormattedMessage id={`General.paymentMethods.${nextPlan}`} />,
            }}
          />
        </span>
      )}
      <span className={css.status}>
        <strong className={css.strong}>
          <FormattedMessage id="PaymentMethodsSubscriptionActive.status" />
        </strong>
        <FormattedMessage id={`General.paymentMethods.subscriptionStatus.${subscriptionStatus}`} />
        {nextState === SUBSCRIPTION_STATUS.CANCELED && (
          <FormattedMessage
            id={`PaymentMethodsSubscriptionActive.subscriptionCanceled`}
            values={{ expiresAt }}
          />
        )}
      </span>
      {nextState !== SUBSCRIPTION_STATUS.CANCELED && !(nextPlan && nextPlan !== selectedPlan) && (
        <span className={css.renewalDate}>
          <strong className={css.strong}>
            <FormattedMessage id="PaymentMethodsSubscriptionActive.nextRenewalDate" />
          </strong>
          {renewalDateFormatted}
        </span>
      )}

      <p className={css.subscriptionInfo}>
        {nextState === SUBSCRIPTION_STATUS.CANCELED ? (
          <FormattedMessage id="PaymentMethodsSubscriptionActive.renewSubscriptionPrompt" />
        ) : urlInProgress ? (
          <IconSpinner />
        ) : url ? (
          <FormattedMessage
            id="PaymentMethodsSubscriptionActive.visitPortal"
            values={{
              link: (
                <ExternalLink href={url} target="_self">
                  <FormattedMessage id="Global.stripeCustomerPortal" />
                </ExternalLink>
              ),
            }}
          />
        ) : (
          urlError && <></>
        )}
      </p>
    </div>
  );
};

PaymentMethodsSubscriptionActive.propTypes = {
  subscription: object.isRequired,
  url: string,
  urlInProgress: bool,
  urlError: object,
};

export default PaymentMethodsSubscriptionActive;
